import { setupFinePartita } from "./finePartita.js";

export default function sconfitta(k) {
    k.scene("sconfitta", () => {
        setupFinePartita(k, "Mi dispiace, hai perso!");
    });
}
